<template>
    <h5 class="h-100 w-100">
        <div class="ssc h-100 w-100">
            <div class="w-100 h-100 flex flex-column align-center justify-center">
                <template v-if="isParent">
                    <div class="ssc-square w-40" style="height: 20px"></div>
                    <div class="ssc-square w-80 mt-1" style="height: 20px"></div>
                    <div class="ssc-square w-80 mt-1" style="height: 20px"></div>
                </template>
                <div class="ssc-square w-90 h-100" v-else></div>
            </div>
        </div>
    </h5>
</template>
<script>
export default {
    props: {
        isParent: {
            type: Boolean,
            default: false,
        },
    },
}
</script>
